/**
 * Humanize a fieldname into a readable label.
 * Converts snake_case or camelCase to Title Case.
 * 
 * @example
 * humanizeFieldname("item_code") => "Item Code"
 * humanizeFieldname("custom_field_xyz") => "Custom Field Xyz"
 * humanizeFieldname("itemName") => "Item Name"
 */
export function humanizeFieldname(fieldname: string): string {
  if (!fieldname) return "";
  
  // Handle snake_case
  if (fieldname.includes("_")) {
    return fieldname
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  }
  
  // Handle camelCase
  return fieldname
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}

